export default __webpack_public_path__ + "static/media/FrutigerLTW02-65Bold.98c5a163.woff2";